<template>
    <div class="flex lg:flex-row md:flex-row flex-col gap-8 p-4">
        <!-- Left content -->
        <div class="flex-1 text-2xl">
            <h1 class="text-4xl text-violet-900">
                {{ $t("patients.womansHealth.title") }}
            </h1>
            <div
                class="mt-8"
                v-html="`<p>${$t('patients.womansHealth.content')}</p>`"
            ></div>
            <div
                class="mt-4"
                v-html="`<p>${$t('patients.womansHealth.holidayPackage')}</p>`"
            ></div>
        </div>

        <!-- Right content -->
        <div class="flex-1">
            <GroupCard
                :name="$t('patients.womansHealth.title')"
                :items="[
                    'patients.womansHealth.list.perimenopausalDisorders',
                    'patients.womansHealth.list.anemia',
                    'patients.womansHealth.list.weightDisorder',
                    'patients.womansHealth.list.hyperthyreosisAndHypothyreosisInPregnancy',
                    'patients.womansHealth.list.arrhythmiasInPregnancy',
                    'patients.womansHealth.list.insulinResistance',
                    'patients.womansHealth.list.diabetesInPregnancy',
                    'patients.womansHealth.list.discomfortInChest',
                    'patients.womansHealth.list.cardioVascularRisks',
                    'patients.womansHealth.list.weightLoss',
                    'patients.womansHealth.list.pregnancyRelatedProblems',
                ]"
                :itemBackgroundColor="'bg-violet-900'"
                :bgColor="'bg-violet-900'"
                :titleColor="'text-white'"
                :textColor="'text-white'"
                :link="href"
                :price="1999"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import GroupCard from "~/components/GroupCard.vue";
import { useLanguagesStore } from "~/stores/languages";

const languageStore = useLanguagesStore();

// Make href reactive
const href = computed(
    () =>
        (languageStore.getSelectedLanguage === "no"
            ? "https://booking.pridok.no/appointment/e6af7ac5-8fcb-48d7-9f39-fb1ee283a522/KAR/df5ef6a7-f1f4-4003-9433-a92233d6c067"
            : "/contact") as string,
);
</script>

<style scoped></style>
